(function processFrontend($, window) {
    $(document).on('cms.ready', ready);

    let element_active = 'process__element--active',
        icon_active = 'process__icon--active';

    let logged_in = false; // Nice-to-have: Logged in as a Contenda variable.

    /* Initial building of the case-slider */
    function ready() {
        logged_in = $('body.logged-in').length;

        let $sections = $('.sectionProcess');
        $sections.each(initializeSection);

        if(logged_in) {
            // Set up intersect listener on document since that's the only way we can listen to newly added elements
            $(document).on('cms.intersect', '.sectionProcess', function(evt, entry, $elm) {
                initializeSection(0, $elm);
                intersect(evt, entry, $elm);
            });
        } else {
            $sections.on('cms.intersect', intersect);
        }
    }

    function intersect(evt, entry, $section) {
        // Start autoplay on section
        if($section.data('autoplay-stopped')) {
            return;
        }
        let interval = setInterval(nextActive, 5000, $section);
        $section.data('interval', interval);
    }

    function initializeSection(idx, elm) {
        let $section = $(elm),
            $elements = $section.find('.process__element'),
            $icons = $section.find('.process__icon');

        if($elements.filter('.'+icon_active).length < 1) {
            $elements.first().addClass(element_active);
            $icons.first().addClass(icon_active);
        }

        $icons.off('click').on('click', function(evt, extra) {
            evt.stopPropagation();

            let index = $(this).index();
            setActiveElement($section, index, extra);
        });

        $elements.off('click').on('click', '.process-element__card-header', function(evt) {
            evt.stopPropagation();

            let index = $(this).parents('.process-element').index();
            setActiveElement($section, index);
        });
    }

    function setActiveElement($section, index, extra) {
        let $elements = $section.find('.process__element'),
            $icons = $section.find('.process__icon');

        let $icon = $icons.eq(index);
        let $element = $elements.eq(index);

        $elements.removeClass(element_active);
        $element.addClass(element_active);

        $icons.removeClass(icon_active);
        $icon.addClass(icon_active);

        if($section.data('interval') && (typeof(extra) === 'undefined' || !extra.automatic)) {
            clearInterval($section.data('interval'));
            $section.data('autoplay-stopped', true);
        }
    }

    function nextActive($section) {
        let $icons = $section.find('.process__icon'),
            $active_icon = $icons.filter('.'+icon_active);

        if($active_icon.length < 1) return;

        let next_index = ($active_icon.index() + 1) % $icons.length;
        $icons.eq(next_index).trigger('click', {automatic:true});
    }

})(jQuery, window);